import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Divider, Link, RadioGroup, Switch, Text } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import AppContext from '@/common/context/app.context'
import { openInNewTab } from '@/common/helpers/helpers'

import { defaultFulfillmentTrigger, fulfillmentTriggerLabels } from '../constants'
import { getSeelDashboardUrl, getShopifyThemeEditorUrl } from '../helpers'
import * as Styles from './styles'

const SeelConfiguration = ({ integration, onChange, hasChanges, onRevertChanges, onSave }) => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)

  const fulfillmentTrigger = integration?.configuration?.fulfillment_trigger
  const autoFulfillmentEnabled = fulfillmentTrigger?.value !== null && fulfillmentTrigger?.value !== undefined

  const fulfillmentOptions = fulfillmentTrigger?.options?.map(option => ({
    value: option,
    label: t(fulfillmentTriggerLabels[option]),
  }))

  const handleToggleAutoFulfillment = event => {
    onChange('fulfillment_trigger', event.target.checked ? defaultFulfillmentTrigger : null)
  }

  const handleFulfillmentTriggerChange = event => {
    onChange('fulfillment_trigger', event.target.value)
  }

  const handleOpenDashboard = () => {
    openInNewTab(getSeelDashboardUrl(integration))
  }

  return (
    <>
      <Divider />

      <Styles.Section>
        <Text version="v4" type="titleS">
          {t('Instalación del widget')}
        </Text>
        <Link
          href={getShopifyThemeEditorUrl(info?.selectedStore?.internal_domain)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('Ver widget en el editor de temas de Shopify')}
        </Link>
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Text version="v4" type="titleS">
          {t('Fulfillment de protección')}
        </Text>
        <Text version="v4" type="bodyMRegular">
          {t(
            'Cuando un cliente compra Worry-Free Delivery® en el checkout, se añade automáticamente un ítem de pedido WFD virtual que representa la cobertura. Puedes elegir si retener este ítem para confirmación o procesarlo de inmediato.'
          )}
        </Text>

        <Switch
          checked={autoFulfillmentEnabled}
          onChange={handleToggleAutoFulfillment}
          label={t('Activar el fulfillment automático del ítem WFD')}
        />

        {autoFulfillmentEnabled && (
          <RadioGroup
            name="fulfillment_trigger"
            value={fulfillmentTrigger?.value}
            options={fulfillmentOptions}
            onChange={handleFulfillmentTriggerChange}
          />
        )}
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Text version="v4" type="titleS">
          {t('Panel de protección')}
        </Text>
        <Text version="v4" type="bodyMRegular">
          {t('Consulta contratos, reclamaciones y analíticas en el panel de protección.')}
        </Text>
        <Styles.ButtonContainer>
          <Button onClick={handleOpenDashboard} variant="outlined">
            {t('Ver dashboard de Seel')}
          </Button>
        </Styles.ButtonContainer>
      </Styles.Section>

      <SaveChangesButtons onSave={onSave} hasChanges={hasChanges} onRevertChanges={onRevertChanges} />
    </>
  )
}

export default SeelConfiguration
